export const toCapitalize = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
  //   return status.replace(/([A-Z])/g, " $1").trim();
};

